/**
 * Назва простору — єдине джерело правди для всього UI.
 *
 * Тримається в одному місці, бо платформа ставиться різним клієнтам: зміна
 * бренду має бути одним значенням у env, а не пошуком по 15 файлах. На
 * відміну від посилань на бота (див. bot-links.ts), тихий дефолт тут
 * безпечний — найгірше, що станеться, це чужа назва в шапці, а не клієнтка,
 * відправлена в чужий Telegram-бот.
 */
export const BRAND_NAME = (import.meta.env.VITE_BRAND_NAME as string | undefined) ?? 'MartaFit Space';

/** Підпис під логотипом на екрані входу. */
export const BRAND_TAGLINE =
  (import.meta.env.VITE_BRAND_TAGLINE as string | undefined) ?? 'Щоденні тренування вдома';

/** Назва, розбита на рядки для великого заголовка на екрані входу
 *  («MartaFit Space» → «MartaFit» / «Space»). */
export const BRAND_NAME_LINES = BRAND_NAME.split(' ');
